<template>
  <div class="report_item_wrapper" ref="alerts">
    <div class="report_header">
      <div class="item_title">
        <i class="iconfont">&#xe6ce;</i>
        <span>{{$t('title.huxipinlv')}}</span>
        <span class="srart_end_time" v-show="echartShows">({{ startTime }} -- {{ endTime }})</span>
      </div>
    </div>
    <div class="echarts_wrapper" v-show="echartShows">
      <!-- 图表数据 -->
      <div class="draw_echarts">
        <keep-alive>
          <div class="chart" ref="chart" :id="id"></div>
        </keep-alive>
      </div>
      <p class="chartTip">*{{$t('tag.shipin')}}</p>
      <div class="parameter">
        <div class="cal">
          <div
            :class="['value',aveBreath.value !=='' &&aveBreath.color!=='normal'?aveBreath.color:'normal']"
          >
            <template v-if="aveBreath!==''">
              <strong>{{aveBreath.value}}</strong>
              <i>{{$t('tag.xinlv.danwei')}}</i>
            </template>
            <template v-else>--</template>
          </div>
          <p class="title">{{$t('tag.breathe.quantianpingjun')}}</p>
        </div>
        <!-- 平均、最高、最低值 -->
        <ul>
          <li class="item">
            <span
              :class="['value',topBreath.value!==''&&topBreath.color!=='normal'?topBreath.color:'normal']"
            >
              <template v-if="topBreath!==''">
                <strong>{{topBreath.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.breathe.zuigao')}}</p>
          </li>
          <li class="item">
            <span :class="['value',lowBreath.value!==''&&lowBreath.color?lowBreath.color:'normal']">
              <template v-if="lowBreath!==''">
                <strong>{{lowBreath.value}}</strong>
                <i>{{$t('tag.xinlv.danwei')}}</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.breathe.zuidi')}}</p>
          </li>
        </ul>
      </div>

      <!-- 健康报告 -->
      <div class="read part-top">
        <div class="header">
          <i class="iconfont">&#xe61d;</i>
          <h2>{{$t('title.secondaryTitle.breatheReport')}}</h2>
        </div>
        <div class="content">
          <div :class="['article',contentShow ? 'show' : 'hidden']">
            <!--  v-for="(item,index) in content" :key="index" -->
            <p>{{content}}</p>
          </div>
          <div :class="['mask',contentShow ? 'show' : 'hidden']" @click="contentToggle">
            <i class="iconfont" v-show="!contentShow">&#xe632;</i>
            <i class="iconfont" v-show="contentShow">&#xe633;</i>
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无数据 -->
    <div class="nodata" v-if="!echartShows">{{$t('tag.breathe.noday')}}</div>
    <!-- 弹窗 -->
  </div>
</template>
<script>
export default {
  name: "dayBreathe",
  props: {
    sendTime: {
      type: String,
      require: true,
      default: ""
    }
  },
  data() {
    return {
      echartShows: true,
      emit: {},
      id: "dayBreathe",
      breathTime: [],
      breathValue: [],
      aveBreath: {},
      topBreath: {},
      lowBreath: {},
      startTime: "00:00",
      endTime: "23:59",
      contentShow: false,
      content: "",
      statec: "",
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    var echartsDom = document.getElementById(this.id);
    var contentHeight = window.getComputedStyle(echartsDom).height;
    var contentWidth = window.getComputedStyle(echartsDom).width;
    echartsDom.style.height = contentHeight;
    echartsDom.style.width = contentWidth;
  },
  methods: {
    getDayDataInfo() {
      let postData = {
        date: this.sendTime,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token
      };
      this.$axios
        .getDayBreathe(this.appType, postData)
        .then(this.getDayDataInfoSucc);
    },
    getDayDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.echartShows = true;
        const data = res.data;
        this.breathTime = [];
        this.breathValue = [];
        for (let item of data.echarts) {
          this.breathTime.push(item.time);
          this.breathValue.push(item.breath);
        }

        this.aveBreath = data.outlineData.aveBreath;
        this.topBreath = data.outlineData.topBreath;
        this.lowBreath = data.outlineData.lowBreath;

        this.startTime = data.outlineData.startTime;
        this.endTime = data.outlineData.endTime;
        this.statec = data.outlineData.statec;
        let p;
        this.content = this.$t("breathe.current");
        // for (let item of this.$t("breathValue.day." + this.statec)) {
        //   p = "<p>" + item + "</p>";
        //   this.content += p;
        // }

        this.init();
        this.setOption(this.options);
      } else {
        this.echartShows = false;
      }
      this.emit.code = res.code;
      // this.emit.time = this.sendTime
      // this.emit.htFlag = this.echartShows
      this.$emit("breathecode", this.emit);
    },

    init() {
      let _this = this;
      this.chart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function() {
        _this.chart = _this.chart.resize();
      });
    },
    setOption(option) {
      if (!this.chart) {
        return;
      }

      this.chart.setOption(option);
    },
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  computed: {
    options() {
      return {
        series: {
          type: "bar",
          sampling: "average",
          data: this.breathValue
        },
        color: "#3596ea",
        grid: {
          containLabel: true,
          top: 20,
          bottom: 10,
          left: 0,
          right: 0
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let val = Number(params[0].value);
            let time = params[0].axisValue;
            let res = ` ${time}<br/> ${val} 次/分`;
            return res;
          }
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#54657e",
              width: 1
            }
          },
          data: this.breathTime
        },
        yAxis: {
          type: "value",
          min: 0,
          interval: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cad3df",
              width: 1
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }
      };
    }
  },
  components: {},
  watch: {
    sendTime: function() {
      this.getDayDataInfo();
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/global.styl';
</style>



// WEBPACK FOOTER //
// src/pages/day-data/components/dayBreathe.vue